import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SearchResult } from 'src/app/components/patient-management-system/patient-management-system.component';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CareTeamService {
  private apiUrl = 'https://ampm-dev-us.f93f-use1.bb5ef68.hsp.philips.com/ctm/fhir/94767b89-6ca5-4972-98f4-a392f80e893a/CareTeam';


  constructor(private http: HttpClient,
    private authService: AuthService
  ) { }
  searchByName(searchTerm: string): Observable<SearchResult[]> {
    if (!searchTerm.trim()) {
      return new Observable<SearchResult[]>(observer => {
        observer.next([]); // Emit an empty array
        observer.complete(); // Complete the observable
      });
    }

    let params = new HttpParams();
    params = params.append('name', searchTerm);

     const headers = new HttpHeaders({
    'Authorization': `Bearer ${this.authService.accessToken}`,
    'Content-Type': 'application/json' 
  });
 console.log('headers:', headers);
    const searchUrl = `${this.apiUrl}/search`;
    return this.http.get<SearchResult[]>(searchUrl, { params, headers });
  }
}
